"use client";

import { useEffect } from "react";
import queryString from "query-string";
import storage from "config/storage";

const checkForAffiliateClickIid = () => {
  const query = queryString.parse(window.location.search);
  const affiliateClickId = query["~click_id"];

  if (Boolean(affiliateClickId) && typeof affiliateClickId === "string") {
    storage.set("affiliateClickId", affiliateClickId, "sessionStorage");
  }
};

export function AffiliateClickId() {
  useEffect(() => {
    checkForAffiliateClickIid();
  }, []);

  return null;
}
